import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Mousewheel } from 'swiper/modules'

function QueryResultProductCardSkeleton() {
    return (
        <div className="space-y-3" aria-hidden>
            <div className="relative aspect-3/4 w-full bg-secondary-background-color rounded-xl overflow-hidden">
                <div className="absolute inset-0 bg-muted-color/35 animate-pulse" />
                <div className="absolute top-2 right-2 h-8 w-8 rounded-full bg-muted-color/50 animate-pulse" />
            </div>
            <div className="space-y-1">
                <div className="h-3 w-4/5 max-w-[220px] bg-muted-color/60 rounded animate-pulse" />
                <div className="h-2.5 w-20 bg-muted-color/45 rounded animate-pulse" />
            </div>
        </div>
    )
}

export default function QueryResultProductsSkeleton({ count = 6 }: { count?: number }) {
    return (
        <Swiper
            modules={[FreeMode, Mousewheel]}
            slidesPerView={2.2}
            spaceBetween={12}
            freeMode={{ enabled: true, momentum: true, momentumRatio: 0.4 }}
            mousewheel={{ forceToAxis: true, releaseOnEdges: true }}
            breakpoints={{
                480: { slidesPerView: 3 },
                768: { slidesPerView: 3.5 },
                1024: { slidesPerView: 4.5 },
            }}
        >
            {Array.from({ length: count }).map((_, i) => (
                <SwiperSlide key={i}>
                    <QueryResultProductCardSkeleton />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export { QueryResultProductCardSkeleton }
